"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContainer = void 0;
const Secrets_1 = __importDefault(require("./Secrets"));
const CustomProvider_1 = __importDefault(require("./CustomProvider"));
const ValueResolver_1 = require("./ValueResolver");
const autobind_1 = __importDefault(require("./autobind"));
const INJECTABLE_DEF = Symbol('injectable-def');
const CONTAINER_ACCESSOR = Symbol('container-accessor');
function noop() {
}
class Container {
    constructor(bundle, resolver = new CustomProvider_1.default()) {
        this.bundle = null;
        this.resolver = null;
        this.instances = {};
        this.resolvers = {};
        this.bundle = bundle;
        this.resolver = resolver;
    }
    has(identifier) {
        return !!this.instances[identifier];
    }
    provide(identifier, resolve = false) {
        const ref = this.bundle.getId(identifier);
        let resolver = null;
        if (this.has(ref)) {
            resolver = this.get(ref);
            return resolve ? resolver.get() : resolver;
        }
        const injectable = this.bundle.get(ref);
        if (injectable) {
            resolver = this.resolve(injectable);
        }
        else {
            resolver = this.resolver.resolve(identifier);
        }
        if (resolver && resolve) {
            return resolver.get() || null;
        }
        return resolver || null;
    }
    get(identifier) {
        const ref = this.bundle.getId(identifier);
        return this.resolvers[ref] || null;
    }
    discard(identifier) {
        const ref = this.bundle.getId(identifier);
        const instance = this.instances[ref] || identifier;
        const def = this.getDef(instance);
        if (def && Secrets_1.default.isDiscardable(def.definition)) {
            delete this.instances[def.id];
        }
    }
    resolve(injectable) {
        const { id, definition } = injectable;
        let instance = this.bundle.instantiate(injectable);
        (0, autobind_1.default)(instance);
        let resolver = this.resolvers[id];
        if (!resolver) {
            if (!Secrets_1.default.isSingleton(definition) || !Secrets_1.default.isDiscardable(definition)) {
                resolver = new ValueResolver_1.FinalValueResolver(() => instance);
            }
            else {
                resolver = this.createValueResolver(injectable, id);
            }
        }
        if (Secrets_1.default.isSingleton(definition)) {
            this.instances[id] = instance;
            this.resolvers[id] = resolver;
        }
        instance[INJECTABLE_DEF] = Object.assign({}, injectable);
        setContainer(instance, this);
        this.invokeEagers(instance);
        this.invokePostConstruct(instance);
        return resolver;
    }
    createValueResolver(injectable, id) {
        return new ValueResolver_1.ValueResolver(() => {
            if (!this.instances[id]) {
                this.resolve(injectable);
            }
            return this.instances[id] || null;
        });
    }
    invokeEagers(instance) {
        const eagers = Secrets_1.default.getEagers(instance);
        eagers.forEach(eager => noop(instance[eager]));
    }
    invokePostConstruct(instance) {
        const methodName = Secrets_1.default.getPostContruct(instance);
        if (methodName) {
            instance[methodName]();
        }
    }
    getDef(instance) {
        return instance[INJECTABLE_DEF];
    }
}
exports.default = Container;
function setContainer(injectable, container) {
    injectable[CONTAINER_ACCESSOR] = container;
}
function getContainer(injectable) {
    return injectable[CONTAINER_ACCESSOR];
}
exports.getContainer = getContainer;
//# sourceMappingURL=Container.js.map